import { useState, useEffect,useRef } from 'react';
import './hariHariOMB.scss';
import hariPenetasan from './hariPenetasan.js';
import hariPembentukan1 from './hariPembentukan1';
import hariPembentukan2 from './hariPembentukan2';
import kuliahPedana from './kuliahPerdana';
import TopInfo from "../../Components/TopInfo/TopInfo";
import Heading from '../../Components/Heading/Heading';
import { useParams, useNavigate } from 'react-router-dom';

import bg1 from "../../Assets/HariHariOMB/BG1.png";
import bg2 from "../../Assets/HariHariOMB/BG2.png";
import bg3 from "../../Assets/HariHariOMB/BG3.png";
import downloadDrive from "../../Assets/HariHariOMB/downloadDrive.svg";

const HariHariOMB = () => {
    const [day, setDay] = useState(0);
    const navigate = useNavigate();
    // MODAL
    const [modal, setModal] = useState(false);
    const Modal = useRef(null);
    const [foto, setFoto] = useState(null);
    //routing
    const { hariID } = useParams();

    function openModal(props){
        setModal(!modal);
        setFoto(props);
    }

    // HANLDE CLOSE MODAL
    useEffect(() => {
        const handleClickRemoveModal = (event) => {
          if (!modal == false) {
            if (Modal.current) {
              setModal(false);
            }
          }
        };
        document.addEventListener("click", handleClickRemoveModal, true);
        return () => {
          document.removeEventListener("click", handleClickRemoveModal, true);
        };
      }, [modal]);

    useEffect(() => {
        if (hariID == "hari-penetasan") {
            setDay(0);
        } else if (hariID == "pembentukan-hari-1") {
            setDay(1);
        } else if (hariID == "pembentukan-hari-2") {
            setDay(2);
        } else if (hariID == "kuliah-perdana") {
            setDay(3);
        }else {
            navigate("/");
        }
    })

    const array = [
        {
            title: "Hari Penetasan",
            bg : bg1,
            subTitle: "Hari Penetasan merupakan tahap awal mahasiswa baru dalam membentuk diri menjadi insan yang baru dari seorang siswa menjadi mahasiswa, serta bertujuan mempersiapkan mahasiswa baru mencetak sejarah baru di OMB UMN 2023.",
            asset: hariPenetasan,
            linkDrive: "https://drive.google.com/drive/folders/14-lRcRRP1FHqmx3UIxC7wZt0mBMkED3P",
        },
        {
            title: "Pembentukan Hari 1",
            bg : bg2,
            subTitle: "Pembentukan Hari 1 mengajak mahasiswa baru untuk mengenal Universitas Multimedia Nusantara melalui konten-konten yang telah disediakan panitia OMB UMN 2023.",
            asset: hariPembentukan1,
            linkDrive: "https://drive.google.com/drive/folders/1RetpD4sw5S87Z7ZKWwQPCOBUjNCYWzSA",
        },
        {
            title: "Pembentukan Hari 2",
            bg : bg3,
            subTitle: "Pembentukan Hari 2 melambangkan tahap akhir transisi mahasiswa baru dari siswa menjadi mahasiswa yang siap untuk terjun ke dalam dunia perkuliahan.",
            asset: hariPembentukan2,
            linkDrive: "https://drive.google.com/drive/folders/1-U-xcimqOI2POx2upy0lMRiuQSSPIW0e",
        },
        {
            title: "Kuliah Perdana",
            bg : bg3,
            subTitle: "Setelah mencetak sejarah baru bersama OMB UMN 2023, seluruh peserta wajib menghadiri rangkaian acara Kuliah Perdana dan Sidang Senat Terbuka. Di sini seluruh Pejuang Kupu-kupu Bidadari telah resmi menjadi mahasiswa Universitas Multimedia Nusantara.",
            asset: kuliahPedana,
            linkDrive: "https://drive.google.com/drive/folders/1adZB2EkEmY0kzGd5op-dkcuM79lqJmeY",
        },
    ];

    return (
        <>
            <div className="hariHariOMB__section" style={{backgroundImage: `url(${array[day].bg})`,backgroundSize:"100% 100%"}}>
                <TopInfo />
                <Heading nama={array[day].title} job={array[day].subTitle} />
                <div className="hariHariOMB__aksesBox">
                    <div>
                        <p>Mau lihat semua dokumentasi?</p>
                        <div className="aksesDriveDiv">
                            <img src={downloadDrive} alt="" />
                            <a href={array[day].linkDrive} target='_blank'>Akses <i>Drive</i></a>
                        </div>
                    </div>
                </div>
                <div className="hariHariOMB__photoGrid">
                    {array[day].asset.map((item, index) => {
                        return(
                            <img src={item.img} class= {`photo${index+1}`} onClick={() => openModal(item.img)} key={item.id}/>
                        )
                    })}
                </div>
                
            </div>
            {modal ? 
                <div ref={Modal} id="comingsoon" className="comingsoon">
                    <div className="modal-content">
                        <img className="foto" src={foto} alt="" />
                    </div>
                </div>
            : null }
        </>

    );
}

export { HariHariOMB };